export default "__VITE_ASSET__45ea2f16__"